import { TabbedContainer as tb, TabPane as tp } from './TabbedContainer';
export const TabbedContainer = tb;
export const TabPane = tp;
